import { Icons } from '@agro-club/agroclub-shared'
import { FC, useState } from 'react'
import { AButton } from 'views/components/Analytics'
import { Logistician } from '../../types'
import { RateType, RatesProductTypes } from '../types'
import { EditRoadRatesModal } from './EditRoadRatesModal'

interface Props {
  regionIds?: string[]
  onSuccess: () => void
  ratesData: RateType[]
  responsibleLogisticians?: Logistician[]
  currentProductType?: RatesProductTypes
}

export const EditRoadRatesCell: FC<Props> = ({
  regionIds,
  onSuccess,
  ratesData,
  responsibleLogisticians,
  currentProductType,
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  return (
    <>
      <AButton id="edit" color="secondary" Icon={Icons.IconEdit} size="small" onClick={() => setIsModalOpen(true)} />

      {isModalOpen && (
        <EditRoadRatesModal
          onClose={() => setIsModalOpen(false)}
          regionIds={regionIds}
          refetch={onSuccess}
          ratesData={ratesData}
          responsibleLogisticians={responsibleLogisticians}
          currentProductType={currentProductType}
        />
      )}
    </>
  )
}
